import { render, staticRenderFns } from "./transfer-product.vue?vue&type=template&id=2dd0e177&scoped=true&"
import script from "./transfer-product.vue?vue&type=script&lang=tsx&"
export * from "./transfer-product.vue?vue&type=script&lang=tsx&"
import style0 from "./transfer-product.vue?vue&type=style&index=0&id=2dd0e177&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd0e177",
  null
  
)

export default component.exports